module.exports = __webpack_public_path__ + "img/r-doctor.3b71be21.png";